import store from '@/store'

// 最高权限人员
const topLevelRole = ['总监', '总监助理', '超级管理员', '项目管理', '原创总监助理', '原创总监']

// 审核价格的角色
const priceExamineRole = ['人事总监', '超级管理员']

// 文案相关角色
const writingRole = ['文案组员', '文案组长', '文案主管', '文案', '文案审核']

// 配音相关角色
const dubbingRole = ['配音组员', '配音组长', '配音']

// 后期文件可看
const laterFileRole = ['后期组员', '后期组长', '后期主管', '总部后期组员', '总部后期组长', '总部后期主管', '审核人员', '审核组长', '项目管理', '总监', '总监助理', '超级管理员']

// 配音文件可看
const dubbingFileRole = ['配音组员', '配音组长', '配音主管', '总部配音组员', '总部配音组长', '总部配音主管', '审核人员', '审核组长', '项目管理', '总监', '总监助理', '超级管理员']

// 能修改流程清单的角色
const workEditRole = ['总监', '总监助理', '超级管理员', '项目管理', '总部文案主管', '总部文案组长', '总部后期主管', '总部后期组长', '总部审核组长', '总部配音组长', '原创总监助理', '原创总监']

// 能在流程清单中修改文案节点的角色
const writingPointEditRole = ['总部文案主管', '总部文案组长']

// 能在流程清单中修改后期节点的角色
const laterPointEditRole = ['总部后期主管', '总部后期组长']

// 能在流程清单中修改后期审核节点的角色
const laterAuditPointEditRole = ['总部审核组长']

export const componentMap = {
  GetSubmitOrderBtn: 'get:submit:order:btn',
  GetBatchCheckBtn: 'get:batch:check:btn',
  GetBatchCopyLinkBtn: 'get:batch:copy:link:btn',
  GetBatchPassBtn: 'get:batch:pass:btn',
  GetBatchRejectBtn: 'get:batch:reject:btn',
  GetOperatorOrderCheckBtn: 'get:operator:order:check:btn',
  GetOperatorOrderCancelBtn: 'get:operator:order:cancel:btn',
  GetOperatorOrderDetailBtn: 'get:operator:order:detail:btn',
  GetOperatorDownloadVideoBtn: 'get:operator:download:video:btn',
  GetOperatorVideoDetailBtn: 'get:operator:video:detail:btn',
  GetAssignVideoTaskBtn: 'get:assign:video:task:btn',
  GetAssignSelectToHereBtn: 'get:assign:select:to:here:btn',
  GetAssignAppointHeadmanBtn: 'get:assign:appoint:headman:btn',
  GetSubmitCheckBtn: 'get:submit:check:btn',
  GetDirectorOrderDetailBtn: 'get:director:order:detail:btn',
  GetDirectorAssignVideoTaskBtn: 'get:director:assign:video:task:btn',
  GetDirectorVideoDetailBtn: 'get:director:video:detail:btn',
  GetAssignPointTaskBtn: 'get:assign:point:task:btn',
  GetSaveBtn: 'get:save:btn',
  GetExamineBtn: 'get:examine:btn',
  GetTaskVideoDetailsBtn: 'get:task:video:details:btn',
  GetMineSubmitTaskBtn: 'get:mine:submit:task:btn',
  GetMineVideoDetailsBtn: 'get:mine:video:details:btn',
  GetAddAssigneeBtn: 'get:add:assignee:btn',
  GetEditBtn: 'get:edit:btn',
  GetAddBtn: 'get:add:btn',
  GetPlateEditBtn: 'get:plate:edit:btn',
  GetDeleteBtn: 'get:delete:btn',
  GetPriceAddBtn: 'get:price:add:btn',
  GetPriceUpdateBtn: 'get:price:update:btn',
  GetPriceDeleteBtn: 'get:price:delete:btn',
  GetPriceAuditBtn: 'get:price:audit:btn',
  GetUpdateVideoDetailBtn: 'get:update:video:detail:btn',
  GetDownloadCopywritingAttachmentBtn: 'get:download:copywriting:attachment:btn',
  GetReuploadCopywritingAttachmentBtn: 'get:reupload:copywriting:attachment:btn',
  GetUpdatePointTaskBtn: 'get:update:point:task:btn',
  GetDownloadAttachmentBtn: 'get:download:attachment:btn',
  GetDownloadTaskFileBtn: 'get:download:task:file:btn',
  GetAuditBtn: 'get:audit:btn',
  GetSubmitTaskBtn: 'get:submit:task:btn',
  GetSubmitLaterTaskBtn: 'get:submit:later:task:btn',
  GetAcceptanceBtn: 'get:acceptance:btn',
  GetRollbackBtn: 'get:rollback:btn',
  GetOperatorChangeBtn: 'get:operator:change:btn',
}

// 获取用户角色
const userData = JSON.parse(localStorage.getItem('userData')) || {}
const userRoles = userData.role || []
const componentsVisible = userData.component

export function isComponentVisible(componentName) {
  // return componentsVisible.indexOf(componentName) !== -1
  return true
}

export const can = roleList => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (roleList.includes(userRoles[i])) return true
  }

  return false
}

export const canLike = roleList => {
  for (let i = 0; i < userRoles.length; i += 1) {
    for (let j = 0; j < roleList.length; j += 1) {
      if (userRoles[i].includes(roleList[j])) return true
    }
  }

  return false
}

export const workTypeSelect = canLike(['电商']) ? 'quoteWork' : 'workType'

export const getUserRoles = () => userRoles

// 只有超管能用
export const supremeLevelCan = () => userRoles.includes('超级管理员')

export const topLevelCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (topLevelRole.includes(userRoles[i])) return true
  }

  return false
}

export const workEditCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (workEditRole.includes(userRoles[i])) return true
  }

  return false
}

export const priceExamineCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (priceExamineRole.includes(userRoles[i])) return true
  }

  return false
}

export const writingCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (writingRole.includes(userRoles[i])) return true
  }

  return false
}

export const dubbingCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (dubbingRole.includes(userRoles[i])) return true
  }

  return false
}

// export const laterCan = () => {
//   for (let i = 0; i < userRoles.length; i += 1) {
//     if (laterRole.includes(userRoles[i])) return true
//   }
//
//   return false
// }

export const writingPointEditCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (writingPointEditRole.includes(userRoles[i])) return true
  }

  return false
}

export const laterPointEditCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (laterPointEditRole.includes(userRoles[i])) return true
  }

  return false
}

export const laterAuditPointEditCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (laterAuditPointEditRole.includes(userRoles[i])) return true
  }

  return false
}

export const laterFileRoleCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (laterFileRole.includes(userRoles[i])) return true
  }

  return false
}

export const dubbingFileRoleCan = () => {
  for (let i = 0; i < userRoles.length; i += 1) {
    if (dubbingFileRole.includes(userRoles[i])) return true
  }

  return false
}

export const pointSortMap = {
  writing: 1,
  translate: 2,
  dubbing: 3, // 配音
  storyboarding: 4,
  later: 5, // 后期
  seven: 7, // 剪辑

}

export const authCan = roleList => {
  const { buttonAuth } = store.getters
  for (let i = 0; i < buttonAuth.length; i += 1) {
    if (roleList.includes(buttonAuth[i])) return true
  }

  return false
}

export const authCanLike = roleList => {
  const { buttonAuth } = store.getters
  for (let i = 0; i < buttonAuth.length; i += 1) {
    for (let j = 0; j < roleList.length; j += 1) {
      if (buttonAuth[i].includes(roleList[j])) return true
    }
  }

  return false
}
